module.exports = __webpack_public_path__ + "img/doc_empty.00aab4e0.svg";